import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userCurrentUser, publicCurrency } from '@/utils/api/common';
import { storage } from '@/utils/storage';

const initialState = {
  value: storage.get('language') || 'zh',
  currency: storage.get('currency') || 'CNY',
  currencyList: [],
  formatCurrencyList: [],
  saleCountry: [],
  optionalCountryId: storage.get('optionalCountryId') || '3756',
  company_info: {},
  user_info: {},
};

export const asyncPublicCurrency = createAsyncThunk('lang/asyncPublicCurrency', async (_, { getState }) => {
  const { data: { data = {}, code } } = await publicCurrency();
  const { lang: { currencyList = [] } } = getState();
  if (+code === 0) {
    const { list = [] } = data;
    return list;
  } else {
    return currencyList;
  }
});

export const asyncUserInfo = createAsyncThunk('lang/asyncUserInfo', async (_, { getState }) => {
  const { data: { data = {}, code } } = await userCurrentUser();
  const { lang: { company_info, user_info } } = getState();
  if (+code === 0) {
    const { company_info, user_info } = data;
    storage.set('company_info', company_info);
    storage.set('user_info', user_info);
    // window.localStorage.setItem('token', token || '');
    // window.localStorage.setItem('user_id', user_info?.id?.toString() || '');
    return { company_info, user_info };
  } else {
    return { company_info, user_info };
  }
});

export const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    langChange: (state, payload) => {
      const { currency, language } = payload.payload;
      state.currency = currency;
      state.value = language;
      storage.set('language', language);
      storage.set('currency', currency);
    },
    saleCountryChange: (state, payload) => {
      state.saleCountry = payload.payload;
    },
    optionalCountryChange: (state, payload) => {
      state.optionalCountryId = payload.payload;
      storage.set('optionalCountryId', payload.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncPublicCurrency.fulfilled, (state, { payload = [] }) => {
        state.currencyList = payload;
        state.formatCurrencyList = Object.assign({}, ...payload.map(c => c.exchange_rate));
      })
      .addCase(asyncUserInfo.fulfilled, (state, { payload = {} }) => {
        const { company_info, user_info } = payload;
        state.company_info = company_info;
        state.user_info = user_info;
      });
  }
});

export const { langChange, optionalCountryChange, saleCountryChange } = langSlice.actions;
export const selectedLang = (state) => state.lang.value;

export default langSlice.reducer;